/**
 * GIF Freeze Effect for Product Images
 * Freezes animated GIFs at current frame on hover
 * Supports dynamic content loading
 */

(function() {
  'use strict';
  
  // console.log('GIF Freeze script loaded');

  function initGifFreeze() {
    const gifImages = document.querySelectorAll('.card--product .gif-freezable, .product-link .gif-freezable, .card-wrapper .gif-freezable');
    
    // console.log('Found ' + gifImages.length + ' product GIF(s) to process');

    gifImages.forEach(function(img, index) {
      const parent = img.parentElement;
      
      if (img.dataset.freezeProcessed) {
        return;
      }
      
      img.dataset.freezeProcessed = 'true';

      const canvas = document.createElement('canvas');
      canvas.className = 'frozen-gif';
      canvas.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; opacity: 0; transition: opacity 0.15s ease; pointer-events: none; z-index: 2;';

      parent.style.position = 'relative';
      parent.appendChild(canvas);

      parent.addEventListener('mouseenter', function() {
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
        
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        canvas.style.opacity = '1';
        img.style.opacity = '0';
        
        // console.log('GIF ' + index + ' frozen');
      });

      parent.addEventListener('mouseleave', function() {
        canvas.style.opacity = '0';
        img.style.opacity = '1';
        
        // console.log('GIF ' + index + ' resumed');
      });
    });
  }

  // Initialisation au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGifFreeze);
  } else {
    initGifFreeze();
  }

  // Réinitialisation pour le contenu dynamique
  document.addEventListener('shopify:section:load', initGifFreeze);
  
  // Observer pour détecter les nouveaux produits ajoutés au DOM
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (node.classList.contains('card--product') || node.querySelector('.card--product'))) {
          shouldReinit = true;
        }
      });
    });
    if (shouldReinit) {
      setTimeout(initGifFreeze, 100);
    }
  });

  // Observer le conteneur de produits
  const productGrid = document.querySelector('.collection, .product-grid, [id*="product-grid"]');
  if (productGrid) {
    observer.observe(productGrid, { childList: true, subtree: true });
  }
})();